import {Message} from "@/message";
import {CarInfoInputModel} from "@/model/car-info/car-info-input.model";
import {StringUtils} from "@/string-utils";
import {CarInfoInputErrorMessageModel} from "@/model/car-info/car-info-input-error-message.model";

export class CarInfoInputChecker {

    /** メーカー、車種、車両番号をチェックする */
    public static checkAll(model: CarInfoInputModel): boolean {
        let result: boolean = this.checkMaker(model);
        result = this.checkType(model) && result;
        result = this.checkFrontTirePulldown(model) && result;
        result = this.checkRearTirePulldown(model) && result;
        result = this.checkTransportBranchOffice(model) && result
        result = this.checkClassNumber(model) && result
        result = this.checkHiragana(model) && result
        result = this.checkSerialNumber(model) && result
        result = this.checkSerialNumberRequired(model) && result
        return result;
    }

    /** メーカー、車種、装着タイヤサイズのプルダウンでエラーがあるかチャックする */
    public static checkHaveErrorAtMakerCarTypeFreeInputTireSize(model: CarInfoInputModel): boolean {
        let result: boolean = !!model.errorMessage.makerErrorMsg;
        result = !!model.errorMessage.typeErrorMsg || result;
        result = !!model.errorMessage.frontFreeInputErrorMsg || result;
        result = !!model.errorMessage.reaFreeInputErrorMsg || result;
        return result;
    }

    /**
     * メーカーをチェックします
     * @param model 車両情報
     */
    public static checkMaker(model: CarInfoInputModel): boolean {
        // メーカーが未入力の場合はエラー
        model.errorMessage.makerErrorMsg = (model.maker) ? "" : Message.NOT_CAR_MAKER;
        return !model.errorMessage.makerErrorMsg;
    }

    /**
     * 車種をチェックします
     * @param model 車両情報
     */
    public static checkType(model: CarInfoInputModel): boolean {
        model.errorMessage.typeErrorMsg = (model.type) ? "" : Message.NOT_CAR_TYPE;
        return !model.errorMessage.typeErrorMsg;
    }

    /** 前タイヤの幅、扁平率、リム径の入力チェックをする*/
    public static checkFrontTirePulldown(model: CarInfoInputModel): boolean {
        // 前タイヤの幅、扁平率、リム径、エクストラロード、ランフラットタイヤのいずれかが入力されている場合
        if (model.frontTireWidth || model.frontTireAspectRatio || model.frontRimDiameter || model.frontXL || model.frontRft) {
            // 幅、扁平率、リム径が全て入力されているか確認する
            if (!model.frontTireWidth || !model.frontTireAspectRatio || !model.frontRimDiameter) {
                model.errorMessage.frontFreeInputErrorMsg = Message.NOT_INPUT_WIDTH_ASPECT_RATIO_RIM_XL_Front;
            } else {
                model.errorMessage.frontFreeInputErrorMsg = "";
            }
        } else {
            model.errorMessage.frontFreeInputErrorMsg = "";
        }
        return !model.errorMessage.frontFreeInputErrorMsg;
    }

    /** 後タイヤの幅、扁平率、リム径の入力チェックをする*/
    public static checkRearTirePulldown(model: CarInfoInputModel): boolean {
        // 前タイヤの幅、扁平率、リム径、エクストラロードのいずれかが入力されている場合
        if (model.reaTireWidth || model.reaTireAspectRatio || model.reaRimDiameter || model.reaXL || model.reaRft) {
            // 幅、扁平率、リム径が全て入力されているか確認する
            if (!model.reaTireWidth || !model.reaTireAspectRatio || !model.reaRimDiameter) {
                model.errorMessage.reaFreeInputErrorMsg = Message.NOT_INPUT_WIDTH_ASPECT_RATIO_RIM_XL_Rea;
            } else {
                model.errorMessage.reaFreeInputErrorMsg = "";
            }
        } else {
            model.errorMessage.reaFreeInputErrorMsg = "";
        }
        return !model.errorMessage.reaFreeInputErrorMsg;
    }

    /**
     * 運輸支局をチェックします
     * @param model 車両情報
     */
    public static checkTransportBranchOffice(model: CarInfoInputModel) {
        model.errorMessage.transportBranchOfficeErrorMsg = StringUtils.checkFullWidthCharacter(model.numberPlate.transportBranchOffice) ? "" : Message.NOT_FULL_WIDTH_CHAR;
        return !model.errorMessage.transportBranchOfficeErrorMsg;
    }

    /**
     * 分類番号をチェックします。
     * @param model 車両情報
     */
    public static checkClassNumber(model: CarInfoInputModel): boolean {
        model.errorMessage.classNumberErrorMsg = StringUtils.checkHalfWidthUppercaseAlphaNumeric(model.numberPlate.classNumber) ? "" : Message.NOT_UPPER_ALPHA_NUMERIC;
        return !model.errorMessage.classNumberErrorMsg;
    }

    /**
     * ひらがなをチェックします。
     * @param model 車両情報
     */
    public static checkHiragana(model: CarInfoInputModel) {
        model.errorMessage.hiraganaErrorMsg = StringUtils.checkHiraganaAlphabet(model.numberPlate.hiragana) ? "" : Message.NOT_HIRAGANA_ALPHABET;
        return !model.errorMessage.hiraganaErrorMsg;
    }

    /**
     * 一連指定番号をチェックします。
     * @param model 車両情報
     */
    public static checkSerialNumber(model: CarInfoInputModel): boolean {
        // 数字チェック
        model.errorMessage.serialNumberErrorMsg = (StringUtils.checkNumber(model.numberPlate.number1) &&
            StringUtils.checkNumber(model.numberPlate.number2) &&
            StringUtils.checkNumber(model.numberPlate.number3) &&
            StringUtils.checkNumber(model.numberPlate.number4)
        ) ? "" : Message.NOT_NUMBER;
        return !model.errorMessage.serialNumberErrorMsg;
    }

    /**
     * 一連指定番号の関連必須をチェックします。
     * @param model 車両情報
     */
    public static checkSerialNumberRequired(model: CarInfoInputModel): boolean {
        // 数字チェックでエラーがない場合は、関連必須チェック
        if (!model.errorMessage.serialNumberErrorMsg) {
            if (model.numberPlate.number1 && !model.numberPlate.number2) {
                model.errorMessage.serialNumberErrorMsg = Message.WRONG_SERIAL_NUMBER;
            }
            if (model.numberPlate.number2 && !model.numberPlate.number3) {
                model.errorMessage.serialNumberErrorMsg = Message.WRONG_SERIAL_NUMBER;
            }
            if (model.numberPlate.number3 && !model.numberPlate.number4) {
                model.errorMessage.serialNumberErrorMsg = Message.WRONG_SERIAL_NUMBER;
            }
        }
        return !model.errorMessage.serialNumberErrorMsg;
    }
}